import React from "react";
import { useGetSendListInfoQuery } from "../store/slices/settingsSlice";
import { Link } from "react-router-dom";
import { useGetContactSetsQuery } from "../store/slices/contactsSlice";

export default function SelectableContactFieldError({
  errorMessage,
}: {
  errorMessage: string;
}) {
  const sendListUuids = Array.from(
    errorMessage.matchAll(/send-list:([^,\]]+)/g),
    (match) => match[1]
  );
  const groupUuids = Array.from(
    errorMessage.matchAll(/group:([^,\]]+)/g),
    (match) => match[1]
  );

  if (sendListUuids.length === 0 && groupUuids.length === 0) {
    return <div className="text-danger mb-1">{errorMessage}</div>;
  }

  const sendlistInfo = useGetSendListInfoQuery(
    { uuid: sendListUuids },
    {
      skip: sendListUuids.length === 0,
    }
  );

  const groupsInfo = useGetContactSetsQuery(
    { uuid: groupUuids, perPage: groupUuids.length },
    { skip: groupUuids.length === 0 }
  );

  return (
    <div className="text-danger mb-1">
      {sendListUuids.length > 0 && (
        <div>
          Required by filters in:
          {Object.values(sendlistInfo.data || {}).map((info) => (
            <Link
              className="badge bg-secondary text-white ms-2"
              to={`/library/logic/builder/${info.ProjectID}/${
                info.Kind === "message_template"
                  ? "message-template"
                  : info.Kind
              }/${info.Uuid}/send-list`}
              key={info.Uuid}
            >
              {info.ProjectLabel} - {info.Kind}: {info.Label}
            </Link>
          ))}
        </div>
      )}

      {groupUuids.length > 0 && (
        <div>
          Required by contact groups:
          {groupsInfo.data?.contactSets.map((group: any) => (
            <Link
              className="badge bg-secondary text-white ms-2"
              to={`/assets/contacts/groups/${group.uuid}`}
              key={group.uuid}
            >
              {group.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
